import { useParams } from "react-router-dom";

import Unauthorized from "../../ui/components/Unauthorized/Unauthorized";

import useHasRight from "../../authorization/hooks/useHasRight";

import AgreementTemplateView from "../views/AgreementTemplateView/AgreementTemplateView";

export default function AgreementTemplate() {
	const { id } = useParams();

	const hasRight = useHasRight();

	if (!hasRight("agreements.view")) {
		return <Unauthorized />;
	}

	return <AgreementTemplateView id={id} />;
}
